module.exports = __webpack_public_path__ + "static/media/uflex.2e896c32.svg";